import { ReactNode } from "react";
import { Route } from "react-router";
import { IRouteItem } from "../interfaces";
import { lazy } from "./lazy";

export const authRouteList: IRouteItem[] = [
  {
    name: "Forgot password",
    path: "/forgot-password",
    LazyComponent: lazy(
      () => import("../pages/Forgot-password/Forgotpassword")
    ),
    exact: true,
  },
  {
    name: "Reset password",
    path: "/reset-password-link",
    LazyComponent: lazy(() => import("../pages/Reset-link/Resetlink")),
    exact: true,
  },
  {
    name: "Login",
    path: "/login",
    LazyComponent: lazy(() => import("../pages/Login/Login")),
    exact: true,
  },
  {
    name: "Reset Password",
    path: "/reset-password",
    LazyComponent: lazy(() => import("../pages/ResetPassword/ResetPassword")),
    exact: true,
  },
  {
    name: "Page not found",
    path: "/pagenotfound",
    LazyComponent: lazy(() => import("../pages/Error/Pagenotfound")),
  },
];

const routerDom: ReactNode[] = [];
const parseRoutes = (routeList: IRouteItem[]) => {
  routeList.forEach((route) =>
    routerDom.push(
      <Route
        {...route}
        children={(props) => <route.LazyComponent {...props} route={route} />}
      />
    )
  );
  return routerDom;
};

export const authRoutes = parseRoutes(authRouteList);
